import { createAction, props } from '@ngrx/store';

import { Template, CopyTemplate } from '../models';

export const fetchRequest = createAction(
  '[Email] Fetch Templates Request',
  props<{ accountId: string }>(),
);
export const fetchSuccess = createAction(
  '[Email] Fetch Templates Success',
  props<{ templates: Template[] }>(),
);
export const fetchFailure = createAction('[Email] Fetch Templates Failure');

export const copyRequest = createAction(
  '[Email] Copy Templates Request',
  props<CopyTemplate>(),
);
export const copySuccess = createAction('[Email] Copy Templates Success');
export const copyFailure = createAction('[Email] Copy Templates Success');

export const reBootstrapRequest = createAction(
  '[Email] ReBootstrap request',
  props<{ accountId?: string }>(),
);
export const reBootstrapSuccess = createAction('[Email] ReBootstrap success');
export const reBootstrapFailure = createAction('[Email] ReBootstrap failure');
